<template>
  <Alert
    v-if="showAlert"
    :message="alertMessage"
    :alertType="alertType"
    :closable="alertClosable"
    :alertIcon="alertIcon"
    @onClose="showAlert = false"
  />
  <div class="container" data-testid="card-details">
    <div v-if="displayCioSpaceOn">
      <div
        :id="inlineMessageHtmlId"
        class="mx-auto d-flex flex-column justify-content-between"
      ></div>
      <div
        id="cl-inline-message-container-card-details-general"
        class="mx-auto d-flex flex-column justify-content-between"
      ></div>
      <hr class="mt-3 mb-1 p-0" v-if="!showEligibleUI" />
    </div>
    <!--////////////////////////////// DELINQUENT //////////////////////////////-->
    <DisclaimerBanner
      class="mb-3"
      v-if="payjoyCardStatus !== PayJoyCardStatus.ACTIVE && delinquent"
    >
      <p
        class="text-black mx-auto m-0"
        v-html="t('PAYJOY_CARD_VIEWS.DELINQUENT_DISCLAIMER')"
      ></p>
    </DisclaimerBanner>
    <!--////////////////////////////// CARD CONTAINER //////////////////////////////-->
    <div
      id="card-container"
      :style="cardContainerStyle"
      v-if="showCardContainer"
    >
      <iframe
        :src="showDetails ? iFrameUrl : ''"
        id="card"
        class="w-100 h-100"
        v-if="payjoyCardStatus === PayJoyCardStatus.ACTIVE"
      ></iframe>
      <img
        :src="useAsset('img/credit-line/cc_locked.png')"
        alt="locked card"
        class="w-100"
        v-else-if="payjoyCardStatus === PayJoyCardStatus.BLOCKED"
        id="locked-card-img"
      />
      <img
        v-else
        :src="useAsset('img/credit-line/disabled_card.png')"
        alt="gray card"
        class="w-100"
        id="gray-card-img"
      />
    </div>
    <hr class="mt-3 mb-1 p-0" v-if="showCardContainer && !showEligibleUI" />

    <!--////////////////////////////// SIMULTANEOUS JOIN LINE //////////////////////////////-->
    <div
      class="w-100 mt-4"
      v-if="isSimultaneousLoanLineUser && shouldShowSLLBtns && !showFAQs"
    >
      <Button @click="clickActionBtn" class="mb-3 w-100">
        <img
          class="text-white mb-1"
          :src="useAsset('img/credit-line/credit_card_white.svg')"
          alt="pc svg"
        />
        <span class="text-center ms-2">{{ t("ACTIVATE_MY_CARD") }}</span>
      </Button>
      <div
        class="w-100 d-flex justify-content-center mt-3"
        @click="redirectRequestCardAddressForm"
      >
        <p class="redirect-link">
          <span class="text-center w-100">{{ t("DONT_HAVE_CARD") }}</span>
        </p>
      </div>
    </div>
    <!--////////////////////////////// ELIGIBLE //////////////////////////////-->
    <div v-if="showEligibleUI">
      <EligibleCard
        @goToCardOverview="goToCardOverview"
        @clickActionBtn="clickActionBtn"
      />
    </div>
    <!--////////////////////////////// NONE //////////////////////////////-->
    <CardCTA
      v-if="
        payjoyCardStatus === PayJoyCardStatus.NONE &&
        !showFAQs &&
        !showNotAllowedView
      "
      :button-text="t('PAYJOY_CARD_VIEWS.NO_ELIGIBLE_BTN_TEXT')"
      @link-click="goToCardOverview"
      @btn-click="nonEligibleContactUs"
      :link-text="t('PAYJOY_CARD_VIEWS.WHAT_IS_PC')"
    >
      <div
        class="w-100 h-100 text-center"
        v-html="t('PAYJOY_CARD_VIEWS.NO_ELIGIBLE_TEXT')"
      ></div>
    </CardCTA>

    <!--////////////////////////////// NOT ALLOWED FOR CO //////////////////////////////-->
    <NotAllowedView v-if="showNotAllowedView" />

    <!--// FAQS-->
    <section
      class="mt-2"
      v-if="payjoyCardStatus === PayJoyCardStatus.ELIGIBLE && showFAQs"
    >
      <div class="w-100 p-3">
        <div class="d-flex flex-fill w-100 p-0">
          <p class="ms-auto me-0 right p-0 d-flex" @click="showFAQs = false">
            <span class="text-black d-block me-1" style="margin-top: -3px">{{
              t("CLOSE")
            }}</span>
            <i class="fa fa-times" style="font-size: larger !important"></i>
          </p>
        </div>
        <CollapseCard
          @click="
            triggerAnalyticsEvent(AnalyticEvents.CreditLine.CcClickWhatIsCc)
          "
          :title="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_TITLE1')"
          fill
        >
          <p class="text-black">
            {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_DESCRIPTION1") }}
            <b>{{
              t("PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_DISCLAIMER")
            }}</b>
          </p>
        </CollapseCard>
        <CollapseCard
          @click="
            triggerAnalyticsEvent(
              AnalyticEvents.CreditLine.CcClickWhatarebenefits
            )
          "
          :title="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_TITLE2')"
          fill
        >
          <div class="text-black">
            {{
              t(
                "PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_DESCRIPTION2.HEAD"
              )
            }}
            <ul>
              <li v-for="i in 4" v-bind:key="i">
                {{
                  t(
                    `PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_DESCRIPTION2.ITEM${i}`
                  )
                }}
              </li>
            </ul>
          </div>
        </CollapseCard>
        <CollapseCard
          @click="
            triggerAnalyticsEvent(AnalyticEvents.CreditLine.CcWhereCanUseMyCard)
          "
          :title="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_TITLE3')"
          fill
        >
          <div class="text-black">
            {{
              t(
                "PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_DESCRIPTION3.HEAD"
              )
            }}
            <ul>
              <li v-for="i in 4" v-bind:key="i">
                {{
                  t(
                    `PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_DESCRIPTION3.ITEM${i}`
                  )
                }}
              </li>
            </ul>
          </div>
        </CollapseCard>
      </div>
    </section>
    <!--////////////////////////////// SHIPPED //////////////////////////////-->
    <section v-if="showShippedCardSection">
      <ShippedCard
        :payjoyCardStatus="payjoyCardStatus"
        :creditLineId="creditLineId"
        @reportNotDelivered="confirmModalDisplayed = true"
      />
    </section>
    <!--////////////////////////////// INSTORE //////////////////////////////-->
    <section
      v-if="payjoyCardStatus === PayJoyCardStatus.INSTORE_NEEDS_ACTIVATION"
    >
      <div class="w-100 py-2 d-flex">
        <div class="col">
          <img
            :src="useAsset('img/credit-line/cc_checkmark.svg')"
            alt="tracking"
          />
        </div>
        <div class="col w-100 flex-fill ms-3">
          <h6>{{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_DELIVERED_TITLE") }}</h6>
          <p class="h7 fw-normal">
            {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_DELIVERED_DESCRIPTION") }}
          </p>
        </div>
      </div>
    </section>
    <!--////////////////////////////// ACTIVE OR BLOCKED //////////////////////////////-->
    <section
      v-if="
        payjoyCardStatus === PayJoyCardStatus.ACTIVE ||
        payjoyCardStatus === PayJoyCardStatus.BLOCKED
      "
    >
      <div
        class="w-100 pt-2 d-flex px-3 justify-content-between align-items-center"
      >
        <ImageToggle
          data-testid="card-status-toggle"
          :value="disableCard"
          :defaultIcon="
            useAsset('img/credit-line/credit-card/lock_open_right.svg')
          "
          :toggleIcon="useAsset('img/credit-line/credit-card/lock.svg')"
          :defaultTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_DISABLE_TITLE')"
          :toggleTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ENABLE_TITLE')"
          @input="(val) => pressCardToggle(val)"
        />
        <ImageToggle
          data-testid="details-visibility-toggle"
          :value="showDetails"
          :disable="disableCard"
          :defaultIcon="
            useAsset('img/credit-line/credit-card/visibility_off.svg')
          "
          :toggleIcon="useAsset('img/credit-line/credit-card/visibility.svg')"
          :defaultTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ACTIVE_SHOW_TITLE')"
          :toggleTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ACTIVE_HIDE_TITLE')"
          @input="(val) => (disableCard === false ? (showDetails = val) : null)"
        />
        <ImageToggle
          data-testid="change-pin-button"
          :disable="disableCard"
          :defaultIcon="useAsset('img/credit-line/credit-card/pattern.svg')"
          :toggleIcon="useAsset('img/credit-line/credit-card/pattern.svg')"
          :defaultTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_CHANGE_PIN_TITLE')"
          :toggleTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_CHANGE_PIN_TITLE')"
          @click="redirectPinChange"
        />
      </div>
      <hr class="mb-1 mt-0 p-0" />

      <div
        class="w-100 pt-2 pb-2 px-3 text-center"
        v-if="walletBtnType == 'add'"
      >
        <img
          @click="addToWallet"
          :src="useAsset(addToWalletAsset)"
          alt="Add to Google Wallet"
          class="walletBtn"
        />
      </div>

      <div
        class="col fill-txt d-flex justify-content-between align-items-center hm-2p5"
        v-if="walletBtnType == 'added'"
      >
        <h6 class="mt-1 mb-2 d-flex align-items-center">
          <span
            class="material-symbols-outlined me-2 green"
            style="line-height: 1; vertical-align: middle"
          >
            credit_score
          </span>
          {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_ADDED_TO_WALLET") }}
        </h6>
      </div>

      <hr class="mb-1 mt-1 p-0" v-if="walletBtnType !== 'none'" />

      <div class="mt-2 px-2 green-label">
        {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_NEW_TOOL") }}
      </div>
      <div
        data-testid="calculator-tool-container"
        class="w-100 px-2 py-2 d-flex px-0 justify-content-between align-items-center"
        :style="disableCard ? 'opacity:25%;' : ''"
        @click="navToCalculator"
      >
        <div class="col fill-txt">
          <h6 :class="'mt-1 mb-2'">
            {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_CALCULATOR_TITLE") }}
          </h6>
          <p class="h7 fw-normal mb-2">
            {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_CALCULATOR_DESCRIPTION") }}
          </p>
        </div>
        <div class="col ms-auto me-0 px-0">
          <img
            class="ms-3 me-3 p-0 d-block float-end"
            :src="useAsset('img/credit-line/percentage-icon.svg')"
            alt="key"
          />
        </div>
      </div>
      <hr class="mb-1 mt-0 p-0" />
      <div
        data-testid="benefits-container"
        class="w-100 py-2 d-flex px-2 justify-content-between align-items-center"
        :style="disableCard ? 'opacity:25%;' : ''"
        @click="goToBenefits"
      >
        <div class="col flex-fill">
          <h6 class="mt-1 mb-2">{{ t("PC_BENEFITS_TITLE") }}</h6>
          <p class="h7 fw-normal mb-2"></p>
        </div>
      </div>
    </section>

    <hr
      class="m-0 p-0"
      v-if="payjoyCardStatus !== PayJoyCardStatus.ACTIVE && !showEligibleUI"
    />

    <div
      class="container-report-lost-damaged-card"
      v-if="payjoyCardStatus === PayJoyCardStatus.ACTIVE"
    >
      <p
        class="btn-report-lost-damaged-card"
        @click="handleStartCardReportingProcess"
      >
        {{ t("REPORT_LOST_OR_STOLEN_CARD.HOME_BTN") }}
      </p>
    </div>

    <Button
      @click="clickActionBtn"
      v-if="payjoyCardStatus === PayJoyCardStatus.NONE"
      id="submit-btn"
      :hidden="hideActionBtn"
      :disabled="disableBtn"
      :style="
        payjoyCardStatus !== PayJoyCardStatus.DELIVERED && { bottom: '2%' }
      "
    >
      <div class="text-white text-center my-auto fw-bold btn-text">
        <span class="fs-6">{{ btnText }}</span>
      </div>
    </Button>
  </div>
  <!--//////////////////////MODAL//////////////////////-->
  <Modal :show="confirmModalDisplayed">
    <template #header>
      <div class="d-flex flex-fill w-100 p-0">
        <span class="ms-auto me-0 right p-0" @click="closeModal"
          ><i class="fa fa-times" style="font-size: larger !important"></i
        ></span>
      </div>
      <div class="d-flex flex-row">
        <h5
          class="text-black fw-bolder text-center me-1 w-100"
          id="modal-title-header"
        >
          {{ modalHeaderText }}
        </h5>
      </div>
      <p
        class="w-100 text-black text-center"
        v-if="modalStep === ModalSteps.CONFIRM_ADDRESS"
      >
        {{
          t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_CONFIRM_ADDRESS_DESCRIPTION")
        }}
      </p>
    </template>
    <template #body class="mt-2">
      <p
        v-if="modalStep === ModalSteps.CARD_NOT_RECEIVED"
        class="text-center text-black fs-6"
      >
        {{ t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_DESCRIPTION") }}
      </p>
      <CollapseCard
        v-if="modalStep === ModalSteps.CONFIRM_ADDRESS"
        :collapsable="false"
        bold-title
        :title="t('PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_CONFIRM_YOUR_ADDRESS')"
      >
        <p class="text-black">
          {{
            `${addressInfo?.city} ${addressInfo?.region} ${addressInfo?.neighborhood} ${addressInfo?.street_name} ${addressInfo?.street_number} ${addressInfo?.apartment} ${addressInfo?.floor} ${addressInfo?.zip_code}`
          }}
        </p>
      </CollapseCard>
      <p
        class="text-center p-3 text-black fs-6"
        v-if="modalStep === ModalSteps.INFO_CLOSE"
      >
        {{ t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_THANKS_DESCRIPTION") }}
      </p>
      <hr
        class="w-100"
        :hidden="
          modalStep === ModalSteps.CONFIRM_ADDRESS ||
          modalStep === ModalSteps.DEACTIVATE_CARD
        "
      />
    </template>
    <template #footer>
      <button
        v-if="
          modalStep !== ModalSteps.INFO_CLOSE &&
          payjoyCardStatus !== PayJoyCardStatus.DELIVERED
        "
        id="modal-btn-cta"
        class="mt-3 text-center fw-bold"
        @click="toggleCardOff()"
      >
        {{ t("YES") }}
      </button>
      <button
        v-if="
          modalStep !== ModalSteps.INFO_CLOSE &&
          payjoyCardStatus === PayJoyCardStatus.DELIVERED
        "
        class="mt-3 text-center fw-bold modal-btn"
        @click="continueModalBtn()"
      >
        {{
          payjoyCardStatus !== PayJoyCardStatus.DELIVERED
            ? t("YES")
            : modalStep === ModalSteps.CARD_NOT_RECEIVED
            ? t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_CONTINUE_MODAL_BTN")
            : t("YES")
        }}
      </button>
      <button
        v-if="modalStep !== ModalSteps.INFO_CLOSE"
        class="mt-3 text-center fw-bold modal-btn"
        @click="cancelModalBtn()"
      >
        {{
          payjoyCardStatus !== PayJoyCardStatus.DELIVERED
            ? t("CANCEL")
            : modalStep === ModalSteps.CARD_NOT_RECEIVED
            ? t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_CANCEL_MODAL_BTN")
            : t("NO")
        }}
      </button>
      <button
        v-if="modalStep === ModalSteps.INFO_CLOSE"
        class="mt-3 text-center fw-bold mx-auto modal-btn"
        @click="router.go(0)"
      >
        {{ t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_CLOSE_BTN") }}
      </button>
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import {
  computed,
  getCurrentInstance,
  inject,
  onMounted,
  onBeforeMount,
  ref,
  watch,
} from "vue";
import { Service } from "@/apps/credit-line/services/network.service";
import ImageToggle from "@/apps/credit-line/components/ImageToggle.vue";
import Button from "@/apps/credit-line/components/Button.vue";
import { PayJoyCardStatus } from "@/apps/credit-line/models/PayJoyCardStatus";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useRouter } from "vue-router";
import CollapseCard from "@/apps/credit-line/components/CollapseCard.vue";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import { ErrorHandler } from "@/apps/credit-line/helpers/errorHandlerWithLogger.helper";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import { recorder, RECORDING_APPS } from "@/shared-services/recording.service";
import {
  CustomerType,
  ICardInfo,
} from "@/apps/credit-line/models/CreditLineDetails";
import Modal from "@/apps/credit-line/components/Modal.vue";
import Alert from "@/shared-components/common/Alert.vue";
import DisclaimerBanner from "@/apps/credit-line/components/DisclaimerBanner.vue";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";
import { isAndroid } from "@/apps/credit-line/helpers/platformChecker.helper";
import { getRandomNumberBetweenRange } from "@/apps/credit-line/helpers/misc.helper";
import CardCTA from "@/apps/credit-line/components/CreditCard/CardCTA.vue";
import {
  AvailableFeatures,
  FeatureControlService,
} from "@/apps/credit-line/services/feature-control.service";
import { useStore } from "vuex";
import EligibleCard from "./CardDetails/EligibleCard.vue";
import ShippedCard from "./CardDetails/ShippedCard.vue";
import { LogType } from "@/types/dataDogLogType";
import DatadogLogger from "@/shared-helpers/datadog-logger.helper";
import { cioanalytics } from "@/apps/credit-line/services/customerio.service";
import {
  ensureBiometricForSetting,
  BIOMETRIC_REASON_NOT_AVAILABLE,
} from "@/apps/credit-line/helpers/consumerSettings.helper";
import { SettingsCategory } from "@/shared-models/consumer/SettingsCategory";
import NotAllowedView from "@/apps/credit-line/views/CreditCard/NotAllowedView.vue";

declare const Android: AndroidInterface;

enum ModalSteps {
  CARD_NOT_RECEIVED,
  CONFIRM_ADDRESS,
  INFO_CLOSE,
  DEACTIVATE_CARD,
}
const { t, locale } = useI18n();
const router = useRouter();
const CreditLineService = new Service();
const featureService = new FeatureControlService();
const app = getCurrentInstance()?.appContext.app;
const iFrameUrl = ref<string>();
const showDetails = ref<boolean>(false);
const disableCard = ref<boolean>(false);
const confirmModalDisplayed = ref<boolean>(false);
const alertMessage = ref<string>();
const showAlert = ref<boolean>(false);
const alertIcon = ref<string>("fa fa-exclamation-triangle");
const alertType = ref<string>("alert-danger");
const alertClosable = ref<boolean>(true);
const delinquent = ref<boolean>(false);
const modalStep = ref<ModalSteps>(ModalSteps.CARD_NOT_RECEIVED);
const modalHeaderText = ref<string>();
const showFAQs = ref<boolean>(false);
const payjoyCardStatus = ref<PayJoyCardStatus | undefined>();
const summaryUserCardStatus = ref<PayJoyCardStatus>();
const listOfCardsInWallet = ref<string[]>([]);
const allowCardShipments = inject("allowCardShipments", ref(false));
const cardContainerStyle = computed(() => ({
  backgroundImage: `url(${useAsset("img/credit-line/enabled_card.png")})`,
  backgroundSize: "contain",
}));
const store = useStore();
// Injected property defined in CreditCardDetailsView.vue
const supportsAddToGoogleWallet = inject(
  "googleWalletEnabledForPhysicalCard",
  ref(false)
);
const { fetchSummary } = useCreditLineSummary();

const walletBtnType = computed(() => {
  if (supportsAddToGoogleWallet.value) {
    if (selectedCard.value) {
      if (listOfCardsInWallet.value.length > 0) {
        const selectedCardIsInWallet = listOfCardsInWallet.value.includes(
          selectedCard.value?.lastFour ?? ""
        );
        if (selectedCardIsInWallet) {
          return "added";
        } else {
          return "add";
        }
      } else {
        return "add";
      }
    }
    return "none";
  }

  return "none";
});

const addToWalletAsset = computed(() =>
  locale.value.substring(0, 2) === "en"
    ? "img/credit-line/credit-card/add_to_google_wallet_en.png"
    : "img/credit-line/credit-card/add_to_google_wallet_es.png"
);

const { summary, isLoading: loadingSummary } = useCreditLineSummary();

const showShippedCardSection = computed(
  () =>
    payjoyCardStatus.value !== PayJoyCardStatus.ACTIVE &&
    payjoyCardStatus.value !== PayJoyCardStatus.BLOCKED &&
    payjoyCardStatus.value !== PayJoyCardStatus.NONE &&
    !isSimultaneousLoanLineUser.value &&
    !showEligibleUI.value &&
    !createNewCardStatuses.includes(payjoyCardStatus.value as PayJoyCardStatus)
);

const showNotAllowedView = computed(
  () =>
    payjoyCardStatus.value == PayJoyCardStatus.NONE && !allowCardShipments.value
);

const hideNav = () => {
  if (Android && typeof Android?.hideNav === "function") {
    Android.hideNav();
  }
};

const showEligibleUI = computed(
  () =>
    (createNewCardStatuses.includes(
      payjoyCardStatus.value as PayJoyCardStatus
    ) ||
      (payjoyCardStatus.value === PayJoyCardStatus.DISABLED &&
        summaryUserCardStatus.value === PayJoyCardStatus.ELIGIBLE)) &&
    !showFAQs.value &&
    !isSimultaneousLoanLineUser.value
);

const createNewCardStatuses = [
  PayJoyCardStatus.ELIGIBLE,
  PayJoyCardStatus.REPORTED_UNDELIVERED,
  PayJoyCardStatus.DELIVERY_FAILED,
  PayJoyCardStatus.REJECTED,
  PayJoyCardStatus.CANCELED,
];

const showCardContainer = computed(
  () =>
    (payjoyCardStatus.value === PayJoyCardStatus.ACTIVE ||
      payjoyCardStatus.value === PayJoyCardStatus.BLOCKED ||
      (isSimultaneousLoanLineUser.value &&
        payjoyCardStatus.value !== PayJoyCardStatus.ACTIVE)) &&
    !showEligibleUI.value
);

const selectedCard = computed(() => {
  if (!summary.value) return null;

  const physicalCards = (summary.value.cards ?? []).filter(
    (card) => card.type === "PHYSICAL"
  );

  if (physicalCards.length >= 1) {
    return physicalCards[physicalCards.length - 1];
  } else {
    return null;
  }
});

const isSimultaneousLoanLineUser = computed(
  () => summary.value?.customerType === CustomerType.SIMULTANEOUS_LOAN_LINE
);

const shouldShowSLLBtns = computed(() => {
  const physicalCard =
    (summary.value?.cards ?? []).filter(
      (card) => card.type === "PHYSICAL"
    )[0] || null;
  return (
    (!physicalCard || physicalCard?.status === PayJoyCardStatus.DISABLED) &&
    summary.value?.customerType === CustomerType.SIMULTANEOUS_LOAN_LINE &&
    summary.value?.creditCardStatus === PayJoyCardStatus.ELIGIBLE
  );
});

const ccDeliveryError = computed(
  () =>
    payjoyCardStatus.value === PayJoyCardStatus.DELIVERY_FAILED ||
    payjoyCardStatus.value === PayJoyCardStatus.REPORTED_UNDELIVERED
);

const disableBtn = computed(
  () => loadingSummary.value || delinquent.value === true
);

const btnText = computed(() => {
  if (
    payjoyCardStatus.value === PayJoyCardStatus.NONE ||
    payjoyCardStatus.value === PayJoyCardStatus.ELIGIBLE
  ) {
    return t("PAYJOY_CARD_VIEWS.CC_DETAILS_ORDER_EXPLAINER_BTN");
  }

  if (payjoyCardStatus.value === PayJoyCardStatus.DELIVERED) {
    return t("PAYJOY_CARD_VIEWS.CC_DETAILS_DELIVERED_BTN");
  }

  if (ccDeliveryError.value) {
    return payjoyCardStatus.value === PayJoyCardStatus.REPORTED_UNDELIVERED
      ? t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_CARD_RECEIVED_BTN")
      : t("PAYJOY_CARD_VIEWS.CC_DETAILS_ERROR_BTN");
  }

  return t("PAYJOY_CARD_VIEWS.CC_DETAILS_IN_TRANSIT_BTN");
});

watch(payjoyCardStatus, (val: PayJoyCardStatus) => {
  if (val === PayJoyCardStatus.DELIVERED) {
    modalHeaderText.value = t("PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_QUESTION");
  } else {
    modalStep.value = ModalSteps.DEACTIVATE_CARD;
    modalHeaderText.value = t("CONFIRMTOGGLECARDOFF");
  }
});

const hideActionBtn = computed(() => {
  const isPhysicalCardDisabled =
    (summary.value?.cards ?? []).filter((card) => card?.type === "PHYSICAL")[0]
      ?.status === PayJoyCardStatus.DISABLED;

  const otherFlowStatuses =
    summaryUserCardStatus.value === PayJoyCardStatus.ACTIVE ||
    summaryUserCardStatus.value === PayJoyCardStatus.BLOCKED ||
    summaryUserCardStatus.value === PayJoyCardStatus.NONE ||
    summaryUserCardStatus.value === PayJoyCardStatus.ELIGIBLE;

  if (summary.value?.customerType !== CustomerType.KIOSK) {
    return isPhysicalCardDisabled.value || otherFlowStatuses;
  }

  return otherFlowStatuses;
});

const fetchCardDetails = async (data: "hidden" | "display") => {
  try {
    const res = await CreditLineService.getCardDetails({
      deviceTag: AuthenticationHelper.getDeviceTag() as string,
      data,
      lastFour: selectedCard.value?.lastFour || "",
    });
    if (
      res.data.iframeUrl === "ERROR_OCCURRED" ||
      res.data.iframeUrl === "NOT_FOUND"
    ) {
      // Throw an exception instead of navigating directly
      throw new Error(
        `Invalid iframe URL: ${res.data.iframeUrl}, errorCode: 798`
      );
    }

    // Only set the iframe URL if valid
    iFrameUrl.value = res.data.iframeUrl;
  } catch (error) {
    // Log error for metrics
    ErrorHandler.handleNetworkErrorAndLog(error, () => null, "getCardDetails");
    // Navigate to error display
    router.push({
      name: "CreditLineApiErrorDisplay",
      query: {
        title: t("PAYJOY_CARD_VIEWS.ACTIVATION_ERROR_TITLE"),
      },
    });
  }
};

const toggleCardStatus = async (status: "ACTIVE" | "BLOCKED") => {
  try {
    const res = await CreditLineService.toggleCcStatus({
      deviceTag: AuthenticationHelper.getDeviceTag() as string,
      creditLineId: creditLineId.value as number,
      status,
      lastFour: selectedCard.value?.lastFour || "",
    });
    if (res.data.status) {
      fetchSummary(true);
      payjoyCardStatus.value = res.data.status as PayJoyCardStatus;
    }
  } catch (error) {
    alertMessage.value = t("CARDSTATUSTOGGLEERROR");
    showAlert.value = true;
    if (error.response && error.response.data?.errorCode) {
      setTimeout(() => {
        disableCard.value = false;
      }, 2500);
    } else {
      disableCard.value = false;
      ErrorHandler.handleNetworkErrorAndLog(error);
    }
  }
};

const displayCioSpaceOn = computed(
  () =>
    payjoyCardStatus.value === PayJoyCardStatus.NONE ||
    payjoyCardStatus.value === PayJoyCardStatus.ELIGIBLE ||
    payjoyCardStatus.value === PayJoyCardStatus.DISABLED ||
    (payjoyCardStatus.value === PayJoyCardStatus.ACTIVE &&
      delinquent.value !== true)
);

const inlineMessageHtmlId = computed(() =>
  payjoyCardStatus?.value
    ? "cl-inline-message-container-card-details-" +
      payjoyCardStatus.value?.toLowerCase()
    : "cl-inline-message-container-card-details"
);

onMounted(() => {
  // Merge with any existing creditLineApp object
  window.creditLineApp = {
    ...(window.creditLineApp || {}),
    cardsInWallet,
  };
  recorder(app)?.startRecording(RECORDING_APPS.CREDIT_LINE);
  recorder(app)?.updateRecordingInfo(getRandomNumberBetweenRange(1000000, 1), {
    deviceTag: AuthenticationHelper.getDeviceTag(),
  });

  if (Android && typeof Android?.checkWalletForPayJoyCards === "function") {
    Android.checkWalletForPayJoyCards();
  }

  hideNav();

  summaryUserCardStatus.value = summary?.value?.creditCardStatus;
});

onBeforeMount(() => {
  const deviceTag = ref<string>(AuthenticationHelper.getDeviceTag());
  const space = computed(() => payjoyCardStatus?.value.toLowerCase());

  payjoyCardStatus.value =
    selectedCard.value?.status ?? summary.value?.creditCardStatus;
  disableCard.value = payjoyCardStatus.value === PayJoyCardStatus.BLOCKED;
  if (displayCioSpaceOn.value) {
    DatadogLogger.Log(
      "CustomerIo identify called on Card Details screen",
      {
        space: space.value,
        deviceTag: deviceTag.value,
      },
      LogType.INFO
    );

    cioanalytics?.identify(deviceTag.value);
    cioanalytics?.track("creditline card details screen " + space.value);
  }
});

const getPhysicalCard = (
  cards: Array<ICardInfo>,
  creditCardStatus: PayJoyCardStatus
) => {
  let physicalCards = cards.filter((card) => card.type === "PHYSICAL");

  if (physicalCards.length >= 1) {
    selectedCard.value = physicalCards[physicalCards.length - 1];
    payjoyCardStatus.value = selectedCard.value.status;
    disableCard.value = selectedCard.value.status === PayJoyCardStatus.BLOCKED;
  } else {
    payjoyCardStatus.value = creditCardStatus;
    disableCard.value = creditCardStatus === PayJoyCardStatus.BLOCKED;
  }
};

const goToCardOverview = () => {
  if (payjoyCardStatus.value === PayJoyCardStatus.NONE) {
    router.push({
      name: "CardOverview",
      query: {
        country: summary.value?.country,
        clientEligible: "false",
      },
    });
  } else {
    router.push({
      name: "CardOverview",
      query: {
        firstName: userData.value?.firstName,
        lastName: userData.value?.lastName,
        idNumber: userData.value?.idNumber,
        gender: userData.value?.gender,
        birthDate: userData.value?.birthDate,
        email: userData.value?.email,
        creditLineId: creditLineId.value,
        clientEligible: "true",
      },
    });
  }
};

const nonEligibleContactUs = () => {
  const wpNumber = featureService.getFeatureValue(
    AvailableFeatures.WHATSAPP,
    summary.value?.country,
    "number"
  );
  window.open(`https://wa.me/${wpNumber}`, "_system");
};

const userData = computed(() => summary.value?.user ?? null);
const creditLineId = computed(() => summary.value?.creditLineId);
const userId = computed(() => summary.value?.userId);
const availableCredit = computed(() =>
  Number(summary.value?.availableCredit ?? 0)
);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isTester = computed(() => summary.value?.isTester ?? false);
const addressInfo = computed(() => summary.value?.address);
const shipmentId = computed(() => summary.value?.shipmentId);

watch(summary, (newSummary) => {
  if (!newSummary) return;

  getPhysicalCard(newSummary.cards ?? [], newSummary.creditCardStatus);

  if (isAndroid()) {
    setTimeout(() => Android.finishedLoading(), 500);
  }
});

const triggerAnalyticsEvent = (eventName: string) =>
  logAnalyticsEvent(eventName, "CC_Details");

watch(showDetails, async (newValue) => {
  if (newValue) {
    triggerAnalyticsEvent(AnalyticEvents.CreditLine.CcClickShowDetails);
  }
  await fetchCardDetails(newValue ? "display" : "hidden");
});

const pressCardToggle = async (newValue: boolean) => {
  triggerAnalyticsEvent(AnalyticEvents.CreditLine.CcClickTemporaryDisabled);
  if (newValue) {
    modalStep.value = ModalSteps.DEACTIVATE_CARD;
    modalHeaderText.value = t("CONFIRMTOGGLECARDOFF");
    confirmModalDisplayed.value = true;
  } else {
    disableCard.value = false;
    await toggleCardStatus("ACTIVE");
  }
};

const toggleCardOff = async () => {
  await toggleCardStatus("BLOCKED");
  disableCard.value = true;
  confirmModalDisplayed.value = false;
};

const closeModal = () => {
  confirmModalDisplayed.value = false;
  if (payjoyCardStatus.value === PayJoyCardStatus.DELIVERED) {
    if (modalStep.value === ModalSteps.INFO_CLOSE) {
      router.go(0);
    } else {
      modalStep.value = ModalSteps.CARD_NOT_RECEIVED;
    }
  }
};

const sendReportCardNotReceived = async (correctAddressInCcReport: boolean) => {
  if (shipmentId.value) {
    await CreditLineService.reportNotReceivedCard({
      deviceTag: AuthenticationHelper.getDeviceTag() as string,
      shipmentId: shipmentId.value,
      correctAddressInCcReport,
      creditLineId: store.state?.creditLine?.summary?.creditLineId,
    });
    modalStep.value = ModalSteps.INFO_CLOSE;
    modalHeaderText.value = t(
      "PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_THANKS_TITLE"
    );
  }
};

const continueModalBtn = async () => {
  if (modalStep.value === ModalSteps.CARD_NOT_RECEIVED) {
    if (!addressInfo.value) {
      sendReportCardNotReceived(false);
    } else {
      modalStep.value = ModalSteps.CONFIRM_ADDRESS;
      modalHeaderText.value = t(
        "PAYJOY_CARD_VIEWS.REPORT_UNDELIVERED_CONFIRM_ADDRESS"
      );
    }
  } else {
    sendReportCardNotReceived(true);
  }
};

const cancelModalBtn = async () => {
  if (
    modalStep.value === ModalSteps.DEACTIVATE_CARD ||
    modalStep.value === ModalSteps.CARD_NOT_RECEIVED
  ) {
    confirmModalDisplayed.value = false;
  } else {
    sendReportCardNotReceived(false);
  }
};

const clickActionBtn = () => {
  if (isSimultaneousLoanLineUser.value && shouldShowSLLBtns.value) {
    triggerAnalyticsEvent(
      AnalyticEvents.CreditLine.SimultaneousLoanLineActivateMyCard
    );
    router.push({ name: "CreditCardActivationView" });
    return;
  }

  if (payjoyCardStatus.value === PayJoyCardStatus.REPORTED_UNDELIVERED) {
    triggerAnalyticsEvent(AnalyticEvents.CreditLine.CcClickReceivedCard);
    router.push({ name: "CreditCardActivationView" });
    return;
  }

  if (payjoyCardStatus.value === PayJoyCardStatus.INSTORE_NEEDS_ACTIVATION) {
    triggerAnalyticsEvent(AnalyticEvents.CreditLine.CcClickActivateCard);
    router.push({ name: "CreditCardActivationView" });
    return;
  }

  if (
    summaryUserCardStatus.value === PayJoyCardStatus.ELIGIBLE ||
    ccDeliveryError.value
  ) {
    triggerAnalyticsEvent(AnalyticEvents.CreditLine.CcClickOrderCard);
    router.push({
      name: "CreditCardShippingAddressView",
      query: {
        firstName: userData.value?.firstName,
        lastName: userData.value?.lastName,
        idNumber: userData.value?.idNumber,
        gender: userData.value?.gender,
        birthDate: userData.value?.birthDate,
        email: userData.value?.email,
        creditLineId: creditLineId.value,
      },
    });
  } else {
    triggerAnalyticsEvent(
      payjoyCardStatus.value === PayJoyCardStatus.DELIVERED
        ? AnalyticEvents.CreditLine.CcClickActivateCard
        : AnalyticEvents.CreditLine.CcClickReceivedCard
    );
    router.push({ name: "CreditCardActivationView" });
  }
};

const redirectPinChange = async () => {
  if (disableCard.value === false) {
    const biometricResult = await ensureBiometricForSetting(
      "seeCardPin",
      SettingsCategory.CL_CARDS_PAGE
    );

    const allowNavigation =
      biometricResult.success ||
      biometricResult.reason === BIOMETRIC_REASON_NOT_AVAILABLE;

    if (!allowNavigation) {
      return;
    }

    const creditLineIdValue = creditLineId.value;
    if (!creditLineIdValue) {
      return;
    }

    router.push({
      name: "CreditCardPinChangeView",
      query: {
        biometricVerified: biometricResult.success ? "true" : "false",
      },
    });
  }
};

const navToCalculator = () => {
  if (disableCard.value === false) {
    triggerAnalyticsEvent(
      AnalyticEvents.CreditLine.CcCalculatorNavFromCardScreen
    );
    router.push({
      name: "CreditCardTransactionCalculator",
      query: {
        userId: userId.value,
        creditLineId: creditLineId.value,
        availableCredit: availableCredit.value,
        origin: "cc_main_screen",
      },
    });
  }
};

const redirectRequestCardAddressForm = () => {
  triggerAnalyticsEvent(
    AnalyticEvents.CreditLine.SimultaneousLoanLineDoNotHaveCard
  );
  router.push({ name: "CreditCardShippingAddressView" });
};

const goToBenefits = () => {
  logAnalyticsEvent(
    AnalyticEvents.CreditLine.ClickPCBenefitsFromCard,
    "PC_Benefits",
    "",
    {},
    () => {
      router.push({
        name: "CardBenefitsView",
      });
    }
  );
};

const addToWallet = () => {
  Android.addToGoogleWallet(
    selectedCard.value?.externalCreditCardId ?? "",
    selectedCard.value?.lastFour ?? "",
    getAddressForWallet()
  );
};

const getAddressForWallet = () => {
  const addressForWallet = {
    address1: summary.value?.address?.street_name ?? "",
    address2: summary.value?.address?.street_number ?? "",
    countryCode: summary.value?.country ?? "",
    locality: summary.value?.address?.neighborhood ?? "",
    administrativeArea: summary.value?.address?.region ?? "",
    name: summary.value?.customerName ?? "",
    phoneNumber: summary.value?.customerPhone ?? "",
    postalCode: summary.value?.address?.zip_code ?? "",
  };
  return JSON.stringify(addressForWallet);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cardsInWallet = (cardList: string[]) => {
  listOfCardsInWallet.value = cardList;
};

const handleStartCardReportingProcess = () => {
  router.push({
    name: "ReportCardSteps",
    params: {
      step: "Step-1",
    },
  });
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

#card-container {
  background-repeat: no-repeat;
  aspect-ratio: 328/207;
  width: 100%;
}

.container {
  padding: 14px;
}

#submit-btn {
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 44px;
  margin: 0 auto;
}

#pc-not-received-btn {
  position: fixed;
  bottom: -2%;
  left: 0;
  font-weight: bold;
  right: 0;
  color: $pj-color-green;
  width: 85%;
  margin: 2rem auto;
}

.green-label {
  color: $pj-color-green;
  font-size: 14px;
}

.green {
  color: $pj-color-green;
}

#modal-btn-cta {
  width: 45%;
  border-radius: 10px;
  border: 1px solid var(--main-primary-500, #2c7040);
  background: var(--main-white, #fff);
  color: var(--main-primary-500, #2c7040);
  height: 44px;
  padding: 10px 24px;
  text-align: center;
  font-size: medium;
}

.fill-txt {
  flex: 1 1 50% !important;
}

.modal-btn {
  width: 45%;
  border-radius: 10px;
  background: var(--main-primary-500, #2c7040);
  color: var(--main-white, #fff);
  height: 44px;
  text-align: center;
  font-size: medium;
  border: none;
}

a {
  color: $pj-color-green;
}

.center-image {
  margin: auto;
}

.back-btn-faqs {
  width: 100%;
  height: 2.75rem;
  padding: 0.625rem 1rem;
}

.walletBtn {
  width: 60%;
}

Button {
  border-radius: 0.625rem;
  background: var(--main-primary-500, #2c7040);
  width: 100%;
  height: 2.75rem;
  padding: 0.625rem 1rem;

  & {
    font-family: "Inter", sans-serif;
  }
}

.redirect-link {
  color: #2c7040;
  text-align: center;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Inter, sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  text-decoration: none;
}

.btn-report-lost-damaged-card {
  color: #c9372c;
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  margin-left: 8px;
}

.container-report-lost-damaged-card {
  border-top: 1px solid #d6d6d6;
  padding: 10px 0px;
  margin: 0px;
}
</style>
